import { render } from "./LazyMount.vue?vue&type=template&id=11f93366&scoped=true&ts=true"
import script from "./LazyMount.vue?vue&type=script&lang=ts"
export * from "./LazyMount.vue?vue&type=script&lang=ts"

import "./LazyMount.vue?vue&type=style&index=0&id=11f93366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f93366"]])

export default __exports__